function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["leftIcon", "rightIcon", "componentProps"];
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { useState, useRef, forwardRef, isValidElement } from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography, Grid, ListItemIcon } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import BrandTooltip from "../BrandTooltip";
var StyledMenuItemContainer = styled(Grid)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    background: theme.palette.nestedSubmenu.primary,
    flexDirection: 'column',
    position: 'absolute',
    borderRadius: '5px'
  };
});
var StyledMenuItemLabel = styled(MenuItem)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding-inline: 0.5rem;\n  \n  & .MuiListItemIcon-root {\n    min-width: fit-content;\n    align-items: center;\n    color: inherit;\n  }\n"])));
var RecursiveMenuItem = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var _componentProps$conta, _ref$current, _ref$current2;
  var leftIcon = _ref3.leftIcon,
    rightIcon = _ref3.rightIcon,
    _ref3$componentProps = _ref3.componentProps,
    componentProps = _ref3$componentProps === void 0 ? {} : _ref3$componentProps,
    props = _objectWithoutProperties(_ref3, _excluded);
  var theme = useTheme();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _ref = useRef(null);
  var canShowChevron = !props.disabled && props.children;
  var shouldShowLeftIcon = function shouldShowLeftIcon() {
    return leftIcon || canShowChevron && props.alignment === 'left';
  };
  var shouldShowRightIcon = function shouldShowRightIcon() {
    return rightIcon || canShowChevron && props.alignment === 'right';
  };
  var handleMouseLeave = function handleMouseLeave() {
    setOpen(false);
  };
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    if (props.onClick) {
      props.onClick();
    }
    setOpen(true);
  };
  var handleMouseOver = function handleMouseOver() {
    if (props.disabled) return;
    setOpen(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-helptip": props.dataHelpTip
  }, /*#__PURE__*/React.createElement(Grid, _extends({
    container: true,
    ref: _ref,
    onMouseEnter: function onMouseEnter() {
      return handleMouseOver();
    }
  }, componentProps === null || componentProps === void 0 ? void 0 : componentProps.container, {
    sx: _objectSpread({
      position: 'relative',
      borderTop: props.borderTop && "1px solid ".concat(theme.palette.grey[300]),
      borderBottom: props.borderBottom && "1px solid ".concat(theme.palette.grey[300])
    }, componentProps === null || componentProps === void 0 || (_componentProps$conta = componentProps.container) === null || _componentProps$conta === void 0 ? void 0 : _componentProps$conta.sx),
    onMouseLeave: function onMouseLeave() {
      return handleMouseLeave();
    }
  }), /*#__PURE__*/React.createElement(StyledMenuItemLabel, _extends({
    disableTouchRipple: true,
    disabled: props.disabled,
    sx: [props.hasBorderRadiusBottom && {
      borderRadius: '0 0 5px 5px'
    }, props.hasBorderRadiusTop && {
      borderRadius: '5px 5px 0 0'
    }]
  }, componentProps === null || componentProps === void 0 ? void 0 : componentProps.itemLabel, {
    onClick: function onClick(e) {
      return handleClick(e);
    }
  }), /*#__PURE__*/React.createElement(BrandTooltip, {
    arrow: true,
    placement: "top",
    title: props.label,
    margin: "0.25rem",
    componentProps: {
      childContainer: {
        style: {
          width: '100%',
          gap: '0.5rem'
        }
      }
    }
  }, shouldShowLeftIcon() && /*#__PURE__*/React.createElement(ListItemIcon, null, leftIcon || /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    fontSize: "small"
  })), /*#__PURE__*/isValidElement(props.label) ? props.label : /*#__PURE__*/React.createElement(Typography, {
    noWrap: true
  }, props.label), shouldShowRightIcon() && /*#__PURE__*/React.createElement(ListItemIcon, {
    sx: {
      marginLeft: 'auto'
    }
  }, rightIcon || /*#__PURE__*/React.createElement(ChevronRightIcon, {
    fontSize: "small"
  })))), /*#__PURE__*/React.createElement(StyledMenuItemContainer, {
    sx: [{
      display: open ? 'flex' : 'none',
      left: props.alignment === 'right' ? "".concat(_ref === null || _ref === void 0 || (_ref$current = _ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientWidth, "px") : null,
      right: props.alignment === 'left' ? "".concat(_ref === null || _ref === void 0 || (_ref$current2 = _ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.clientWidth, "px") : null
    }]
  }, props.children)));
});
function NestedMenu(_ref4, ref) {
  var _componentProps$conta2, _componentProps$butto, _componentProps$menu, _componentProps$menu2;
  var text = _ref4.text,
    items = _ref4.items,
    alignment = _ref4.alignment,
    onClickCB = _ref4.onClick,
    _ref4$hideButtonChevr = _ref4.hideButtonChevron,
    hideButtonChevron = _ref4$hideButtonChevr === void 0 ? false : _ref4$hideButtonChevr,
    _ref4$componentProps = _ref4.componentProps,
    componentProps = _ref4$componentProps === void 0 ? {} : _ref4$componentProps;
  var theme = useTheme();
  var _ref = useRef(null);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  function handleClick() {
    setIsOpen(true);
    if (onClickCB) onClickCB();
  }
  function handleClose() {
    setIsOpen(false);
  }
  function handleItemSelect(item) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var itemCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (item.disabled) return;
    if (itemCallback) {
      itemCallback();
    } else if (item.onClick) {
      item.onClick(e, item.value);
    }
    handleClose();
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, _extends({}, componentProps === null || componentProps === void 0 ? void 0 : componentProps.container, {
    ref: _ref,
    sx: _objectSpread({
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      color: 'inherit',
      borderRadius: '5px'
    }, componentProps === null || componentProps === void 0 || (_componentProps$conta2 = componentProps.container) === null || _componentProps$conta2 === void 0 ? void 0 : _componentProps$conta2.sx)
  }), /*#__PURE__*/React.createElement(IconButton, _extends({
    ref: ref,
    disableTouchRipple: true,
    onClick: function onClick() {
      return handleClick();
    },
    size: "small"
  }, componentProps === null || componentProps === void 0 ? void 0 : componentProps.button, {
    sx: _objectSpread({
      justifyContent: 'space-between',
      width: '100%',
      borderRadius: 'inherit',
      color: 'inherit'
    }, componentProps === null || componentProps === void 0 || (_componentProps$butto = componentProps.button) === null || _componentProps$butto === void 0 ? void 0 : _componentProps$butto.sx)
  }), /*#__PURE__*/isValidElement(text) ? text : /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, text), !hideButtonChevron && /*#__PURE__*/React.createElement(ExpandMoreIcon, {
    fontSize: "large"
  }))), /*#__PURE__*/React.createElement(Menu, _extends({
    disableScrollLock: true,
    anchorEl: _ref.current,
    open: isOpen,
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    transformOrigin: {
      horizontal: 'left',
      vertical: 'top'
    },
    onClose: function onClose() {
      handleClose();
    }
  }, componentProps === null || componentProps === void 0 ? void 0 : componentProps.menu, {
    PaperProps: _objectSpread(_objectSpread({
      elevation: 0
    }, componentProps === null || componentProps === void 0 || (_componentProps$menu = componentProps.menu) === null || _componentProps$menu === void 0 ? void 0 : _componentProps$menu.paper), {}, {
      sx: _objectSpread({
        background: theme.palette.nestedSubmenu.primary,
        overflow: 'visible',
        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
        '& .MuiMenu-list': {
          paddingBlock: '0'
        },
        '& .MuiAvatar-root': {
          width: 32,
          height: 32,
          ml: -0.5,
          mr: 1
        }
      }, componentProps === null || componentProps === void 0 || (_componentProps$menu2 = componentProps.menu) === null || _componentProps$menu2 === void 0 || (_componentProps$menu2 = _componentProps$menu2.paper) === null || _componentProps$menu2 === void 0 ? void 0 : _componentProps$menu2.sx)
    })
  }), items.map(function (item, idx) {
    var _item$subItems;
    if (!item) return null;
    return /*#__PURE__*/React.createElement(RecursiveMenuItem, {
      key: idx,
      disabled: item.disabled,
      label: item.label,
      alignment: alignment,
      rightIcon: item.rightIcon,
      leftIcon: item.leftIcon,
      borderTop: item.borderTop,
      borderBottom: item.borderBottom,
      hasBorderRadiusBottom: idx === items.length - 1,
      hasBorderRadiusTop: idx === 0,
      dataHelpTip: item.dataHelpTip,
      onClick: function onClick(e) {
        if (item.disabled || item.subItems) return;
        handleItemSelect(item, e);
      },
      componentProps: _objectSpread({}, componentProps === null || componentProps === void 0 ? void 0 : componentProps.menuItem)
    }, (_item$subItems = item.subItems) === null || _item$subItems === void 0 ? void 0 : _item$subItems.map(function (subItem, idx2) {
      var _componentProps$menuI, _componentProps$menuI2;
      return /*#__PURE__*/React.createElement(BrandTooltip, {
        arrow: true,
        key: idx2,
        placement: "top",
        title: subItem.label,
        margin: "0.25rem",
        componentProps: {
          childContainer: {
            style: {
              width: '100%'
            }
          }
        }
      }, /*#__PURE__*/React.createElement(StyledMenuItemLabel, _extends({
        disabled: item.disabled,
        onClick: function onClick(e) {
          if (item.disabled) return;
          handleItemSelect(item, e, function () {
            return item.onClick && item.onClick(subItem.value);
          });
        }
      }, componentProps === null || componentProps === void 0 || (_componentProps$menuI = componentProps.menuItem) === null || _componentProps$menuI === void 0 ? void 0 : _componentProps$menuI.submenuItem, {
        sx: [idx2 === item.subItems.length - 1 && {
          borderRadius: '0 0 5px 5px'
        }, idx2 === 0 && {
          borderRadius: '5px 5px 0 0'
        }, _objectSpread({}, componentProps === null || componentProps === void 0 || (_componentProps$menuI2 = componentProps.menuItem) === null || _componentProps$menuI2 === void 0 ? void 0 : _componentProps$menuI2.submenuItem.sx)]
      }), /*#__PURE__*/isValidElement(subItem.label) ? subItem.label : /*#__PURE__*/React.createElement(Typography, {
        noWrap: true
      }, subItem.label)));
    }));
  })));
}
export default /*#__PURE__*/forwardRef(NestedMenu);